import { CoveoSearchEngineProvider } from './CoveoSearchEngine';
import './CoveoSearch.scss';
import { StandaloneSearchBoxSlideout } from './Components/StandaloneSearchBoxSlideout';
import { getCoveoSearchPageUrl } from 'Foundation/Configurations/GlobalConfiguration';
export function CoveoStandaloneSearchBoxSlideout(props: { showSearch?: boolean; onOpen?: (isOpen: boolean) => void }) {
  return <StandaloneBoxSlideoutWrapper analyticsEnabled={true} showSearch={props.showSearch} onOpen={props.onOpen} />;
}
interface StandaloneBoxWrapperProps {
  analyticsEnabled: boolean;
  showSearch?: boolean;
  onOpen?: (isOpen: boolean) => void;
}
export function StandaloneBoxSlideoutWrapper({ analyticsEnabled, showSearch, onOpen }: StandaloneBoxWrapperProps) {
  return (
    <CoveoSearchEngineProvider analyticsEnabled={analyticsEnabled}>
      <StandaloneSearchBoxSlideout
        id="ssb-slideout"
        redirectionUrl={getCoveoSearchPageUrl()}
        showSearch={showSearch}
        onOpen={onOpen}
      />
    </CoveoSearchEngineProvider>
  );
}
